import { DossierModel } from '../../../dossier-model/dossier-model';
import { SLEntityType, SLEntityField } from '../entity';

import { find, cloneDeep, forEach, includes } from 'lodash';

const COMPANY_LINK = process.env.COMPANY_LINK;
const SHAREHOLDER_LINK = process.env.SHAREHOLDER_LINK;

const SL_SHAREHOLDER_COMPANY_LINK_TYPE = process.env.SL_SHAREHOLDER_COMPANY_LINK_TYPE;
const SL_SHAREHOLDER_PERSON_LINK_TYPE = process.env.SL_SHAREHOLDER_PERSON_LINK_TYPE;
const SL_ADDRESS_FIELD_NAME = process.env.SL_ADDRESS_FIELD_NAME;
const SL_RCS_FIELD_NAME = process.env.SL_RCS_FIELD_NAME;
const SL_EMAIL_FIELD_NAME = process.env.SL_EMAIL_FIELD_NAME;
const SL_PHONE_FIELD_NAME = process.env.SL_PHONE_FIELD_NAME;

const SL_CAPITAL_FIELD_NAME = process.env.SL_CAPITAL_FIELD_NAME;
const SL_SHARES_COUNT_FIELD_NAME = process.env.SL_SHARES_COUNT_FIELD_NAME;

const READ_ONLY_FIELDS = [SL_CAPITAL_FIELD_NAME, SL_SHARES_COUNT_FIELD_NAME];
const RESERVED_FIELDS = [SL_ADDRESS_FIELD_NAME, SL_RCS_FIELD_NAME, SL_EMAIL_FIELD_NAME, SL_PHONE_FIELD_NAME];

export interface Field {
  label: string
  key: string
  fullKeys: string[]
  values: string[]
  input: string
  model: SLEntityField
  readonly: boolean
}

function canAdd(val: any, key: string) {
  if (val.is_name) {
    return false;
  }

  if (includes(RESERVED_FIELDS, key)) {
    return false;
  }

  return true;
}

function buildField(item: any, key: string, parentKey: string): Field {
  return {
    key,
    label: item.label,
    fullKeys: [`${parentKey}.${key}`],
    input: item.input,
    values: item.values,
    model: null,
    readonly: includes(READ_ONLY_FIELDS, key),
  };
}

export function buildExtraFields(dossierModel: DossierModel, entityType: SLEntityType): Field[] {
  const fields: Field[] = [];

  if (entityType === 'COMPANY') {

    // Get root link fields
    const rootLink = find(dossierModel.data, (val, key) => val.is_root);
    
    forEach(rootLink.types['default'], (val, key) => {
      if (canAdd(val, key)) {
        const item = cloneDeep(val);

        fields.push(buildField(item, key, COMPANY_LINK));
      }
    });
  }
  
  
  // Get root link fields
  const shareholderLink = find(dossierModel.data, (val, key) => key === SHAREHOLDER_LINK);

  const shareholderLinkType = entityType === 'COMPANY' ? SL_SHAREHOLDER_COMPANY_LINK_TYPE : SL_SHAREHOLDER_PERSON_LINK_TYPE;
  
  forEach(shareholderLink.types[shareholderLinkType], (val, key) => {
    if (canAdd(val, key)) {
      const item = cloneDeep(val);

      const fullKey = `${SHAREHOLDER_LINK}.${key}`;

      let field = find(fields, f => f.key === key);

      if (field) {
        field.fullKeys.push(fullKey);
      }
      else {
        fields.push(buildField(item, key, SHAREHOLDER_LINK));
      }
    }
  });
  
  return fields;
}